export enum EStatutsSpeciaux {
    UnitesMecanique = 901,
    PiecesMecanique = 902,
    UnitesMecaniquePotentielles = 903,
}